import React, { useState } from "react";

export default function AdjustInventoryModal({
  isOpen,
  onClose,
  onAdjustStock,
  items = [],
}) {
  const [selectedSku, setSelectedSku] = useState(items[0]?.sku || "");
  const [physicalCount, setPhysicalCount] = useState("");
  const [reason, setReason] = useState("Audit Discrepancy");
  const [notes, setNotes] = useState("");

  if (!isOpen) return null;

  const currentItem = items.find((item) => item.sku === selectedSku) || items[0];

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!currentItem || physicalCount === "") return;
    const newQty = parseInt(physicalCount, 10);
    onAdjustStock(currentItem.sku, newQty, reason);
    onClose();
  };

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content shadow-lg border-0 rounded-lg">
          <div className="modal-header bg-warning text-dark py-3">
            <h5 className="modal-title font-weight-bold mb-0">
              <i className="fas fa-sliders-h mr-2"></i>Adjust Inventory Stock Count
            </h5>
            <button type="button" className="close text-dark opacity-100" onClick={onClose}>
              <span>&times;</span>
            </button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body p-4">
              <div className="form-group">
                <label className="font-weight-600">Select Product / SKU *</label>
                <select
                  className="form-control"
                  value={selectedSku}
                  onChange={(e) => setSelectedSku(e.target.value)}
                >
                  {items.map((item) => (
                    <option key={item.sku} value={item.sku}>
                      {item.name} ({item.sku}) - System Qty: {item.quantity}
                    </option>
                  ))}
                </select>
              </div>

              {currentItem && (
                <div className="card bg-light border-0 p-3 mb-3">
                  <div className="row text-center">
                    <div className="col-4">
                      <small className="text-muted d-block">Current System Stock</small>
                      <strong className="h5 text-dark mb-0">{currentItem.quantity} units</strong>
                    </div>
                    <div className="col-4">
                      <small className="text-muted d-block">Warehouse</small>
                      <span className="badge badge-info">{currentItem.warehouse}</span>
                    </div>
                    <div className="col-4">
                      <small className="text-muted d-block">Bin Location</small>
                      <span className="badge badge-secondary">{currentItem.binLocation}</span>
                    </div>
                  </div>
                </div>
              )}

              <div className="form-row">
                <div className="form-group col-md-6">
                  <label className="font-weight-600">Physical Stock Count *</label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter verified physical count"
                    value={physicalCount}
                    onChange={(e) => setPhysicalCount(e.target.value)}
                    required
                    min="0"
                  />
                </div>
                <div className="form-group col-md-6">
                  <label className="font-weight-600">Adjustment Reason</label>
                  <select
                    className="form-control"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                  >
                    <option value="Audit Discrepancy">Audit Discrepancy</option>
                    <option value="Damaged Goods">Damaged Goods</option>
                    <option value="Shrinkage / Theft">Shrinkage / Theft</option>
                    <option value="Returned to Supplier">Returned to Supplier</option>
                    <option value="Stock Correction">Stock Correction</option>
                  </select>
                </div>
              </div>

              <div className="form-group mb-0">
                <label className="font-weight-600">Audit Notes / Comments</label>
                <textarea
                  className="form-control"
                  rows="3"
                  placeholder="Additional explanation for inventory adjustment..."
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                ></textarea>
              </div>
            </div>
            <div className="modal-footer bg-light px-4 py-3">
              <button type="button" className="btn btn-secondary px-4" onClick={onClose}>
                Cancel
              </button>
              <button type="submit" className="btn btn-warning text-dark font-weight-bold px-4">
                <i className="fas fa-save mr-2"></i>Apply Adjustment
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
